/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectTermsAndConditionsResource
 */
export interface ProjectTermsAndConditionsResource {
    /**
     * 
     * @type {string}
     * @memberof ProjectTermsAndConditionsResource
     */
    termsId: string;
    /**
     * 
     * @type {Date}
     * @memberof ProjectTermsAndConditionsResource
     */
    lastModificationDate: Date;
}

/**
 * Check if a given object implements the ProjectTermsAndConditionsResource interface.
 */
export function instanceOfProjectTermsAndConditionsResource(value: object): value is ProjectTermsAndConditionsResource {
    if (!('termsId' in value) || value['termsId'] === undefined) return false;
    if (!('lastModificationDate' in value) || value['lastModificationDate'] === undefined) return false;
    return true;
}

export function ProjectTermsAndConditionsResourceFromJSON(json: any): ProjectTermsAndConditionsResource {
    return ProjectTermsAndConditionsResourceFromJSONTyped(json, false);
}

export function ProjectTermsAndConditionsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectTermsAndConditionsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'termsId': json['termsId'],
        'lastModificationDate': (new Date(json['lastModificationDate'])),
    };
}

export function ProjectTermsAndConditionsResourceToJSON(value?: ProjectTermsAndConditionsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'termsId': value['termsId'],
        'lastModificationDate': ((value['lastModificationDate']).toISOString()),
    };
}

